export const recurringValues: { [key: string]: string } = {
    "3600": "Hourly",
    "86400": "Daily",
    "604800": "Weekly",
    "2592000": "Monthly",
    "31536000": "Yearly",
};
